export const useGeoLocation = () => {
  const route = useRoute()
  const userStore = useUserStore()

  // Create a state variable that is initialized with the request headers on the server.
  const geoHeaders = useState("geoHeaders", () => {
    // Only on the server will useRequestHeaders() be available
    return import.meta.server ? useRequestHeaders() : {}
  })

  const getGeoLocation = () => {
    if (route.query.geo) {
      // TODO: Don't allow query manipulation in production
      return route.query.geo.toUpperCase()
    } else {
      // Use the user store values or geo header values stored in our state
      const country =
        userStore?.country?.value ||
        geoHeaders.value?.["cloudfront-viewer-country"] ||
        "US"
      const region =
        userStore?.region?.value ||
        geoHeaders.value?.["cloudfront-viewer-country-region"]
      return region ? `${country}-${region}` : country
    }
  }

  const ageRestrictedAreas = [
    "GB",
    "UK",
    "US-AL",
    "US-AR",
    "US-AZ",
    "US-FL",
    "US-GA",
    "US-ID",
    "US-IN",
    "US-KS",
    "US-KY",
    "US-LA",
    "US-MO",
    "US-MS",
    "US-MT",
    "US-NC",
    "US-NE",
    "US-OH",
    "US-OK",
    "US-SC",
    "US-SD",
    "US-TN",
    "US-TX",
    "US-UT",
    "US-VA",
    "US-WY",
  ]

  const location = getGeoLocation()
  const splitLocation = location.split("-")
  const country = splitLocation[0]
  const region = splitLocation.length > 1 ? splitLocation[1] : null

  const inAgeRestrictedLocation =
    ageRestrictedAreas.includes(location) ||
    ageRestrictedAreas.includes(country)

  return {
    country,
    region: region || null,
    location,
    inAgeRestrictedLocation,
  }
}
